import expectionalCountries from '../services/convertedCurrencies.json';

/**
 * There is requirement where for a subset of countries, local currencies needed to be shown,
 * expectionalCountries is a list of countries where exceptions are mentioned with their conversion rates
 *
 * @param {country} country: the input country code(ISO alpha 3 letter code) to be matched.
 * @return {exceptionCountry} exceptionCountry: A country json object which has the exceptional details
 */
export const checkForConversions = (country: string) => {
  const matched = expectionalCountries.filter(
    (objects) => objects.country === country,
  )[0];
  return matched;
};
